export default __webpack_public_path__ + "static/blog-04-900x678-876bc4ce34330671eb8eb081119ee9d1.jpg";